import {useDispatch} from 'react-redux';
import {setModalAlert} from '../../reducers/app/actions';

const getTotalAmount = points => {
    const total_amount = points.sort((a,b) => {
        if(a.amount < b.amount) return 1;
        if(a.amount > b.amount) return -1;
        return 0;
    })[0];

    return total_amount ? total_amount.amount : 1;
}

const getCurrentBonus = (points, amount, defaultPercent) => {
    points = points.sort((a, b) => {
        if(a.amount < b.amount) return -1;
        if(a.amount > b.amount) return 1;
        return 0;
    })

    let bonus = defaultPercent;
    for(const point of points)
        if(point.amount <= amount)
            bonus = point.bonus;

    return bonus;
}

export default ({
    points,
    amount,
    defaultPercent = 0,
    method=""
}) => {
    const total_amount = getTotalAmount(points),
          current_bonus = getCurrentBonus(points, amount, defaultPercent),
          dispatch = useDispatch();

    return (
        <div className={`deposit_bonus ${method}`} onClick={e => dispatch(setModalAlert({
            type: 'info',
            title: 'Deposit Bonus',
            text: 'The amount of your bonus depends on the deposit amount. The higher the deposit amount, the more bonus you will receive!',
            button: `That's cool !`
        }))}>
            <div className="top">
                <div className="title">Deposit bonus</div>
                <div className="value">
                    <span>+{current_bonus}</span>%
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.75 3.06L11.64 7.95C12.2175 8.5275 12.2175 9.4725 11.64 10.05L6.74999 14.94" stroke="#A8D81A" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    $ <span>{parseFloat((amount * ((100 + current_bonus) / 100)).toFixed(2))}</span>
                </div>
            </div>
            <div className="progress">
                <div className="line">
                    <div className="line-progress" style={{width: ((amount / total_amount)*100) + '%'}}></div>
                </div>
                <div className="ticks">
                    <div className={`tick ${current_bonus === 0 ? 'active' : ''}`}>
                        <div className="line" style={{opacity: 0}}></div>
                        <div className="value">{defaultPercent}%</div>
                    </div>

                    {points.map((point, key) => {
                        return (
                            <div className={`tick ${point.bonus == current_bonus ? 'active' : ''}`} style={{
                                marginLeft: `calc(((100vw - 80px) * ${point.amount / total_amount}) - 20px)`
                            }} key={key}>
                                <div className="line"></div>
                                <div className="value">{point.bonus}%</div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}